export const providerData=[
    {
        "providerId":1,
        "providerFirstName": "John4443354",
        "providerLastName":"Smith",
        "providerNPI": 20004443354,
        "selcetedProvider":"Y"
    },
    {
        "providerId":2,
        "providerFirstName": "John4443676",
        "providerLastName":"Smith",
        "providerNPI": 20004443676,
        "selcetedProvider":"Y"
    },
    {
        "providerId":3,
        "providerFirstName": "John4449046",
        "providerLastName":"Smith",
        "providerNPI": 20004449046,
        "selcetedProvider":"Y"
    },
    {
        "providerId":4,
        "providerFirstName": "John4444357",
        "providerLastName":"Smith",
        "providerNPI": 20004444357,
        "selcetedProvider":"Y"
    },
    {
        "providerId":5,
        "providerFirstName": "John4443878",
        "providerLastName":"Smith",
        "providerNPI": 20004443878,
        "selcetedProvider":"Y"
    }

];

export const data = [
    {
     "coveredEntity": "Covered Entity #1",
     "pharmacyName": "Walmart Pharmacy #154",
     "pharmacyNPI": 10000000154,
     "transactionCode": "B1   ",
     "bin": 4336,
     "pcn": "ADV",
     "group": "SCB15",
     "otherCoverageCode": "  ",
     "rx": 30004443354,
     "refill": 0,
     "switchDate": "07\/13\/2022",
     "writtenDate": "07\/13\/2022",
     "serviceDate": "07\/13\/2022",
     "claimCapturedDate": "07\/13\/2022",
     "mrn": "MR0004443354",
     "patientFirstName": "John 4443354",
     "patientLastName": "Smith",
     "patientGender": "M ",
     "patientDOB": "01\/01\/1980",
     "prescriber": "John4443354 Smith",
     "prescriberNPI": 20004443354,
     "ndc": 59310058020,
     "drugName": "PROAIR RESPICLICK INHAL POWDER",
     "mfgName": "TEVA SPECIALTY",
     "brandOrGeneric": "B ",
     "qty": 1,
     "daysSupply": 17,
     "copay": 59.63,
     "insurancePayment": 0.91,
     "totalPaid": 60.54,
     "estWACRetailCost": 66.21,
     "dispenseFee": 26,
     "claimType": "Third Party",
     "claimSubType": "Captured",
     "replenishment": 100
    },
    
   ];
